import { render, staticRenderFns } from "./cpt-scroll-table-option.vue?vue&type=template&id=97b61cac&scoped=true"
import script from "./cpt-scroll-table-option.vue?vue&type=script&lang=js"
export * from "./cpt-scroll-table-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b61cac",
  null
  
)

export default component.exports